<script setup>
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import LatexDisplay from '@/components/LatexDisplay.vue';

const props = defineProps({
    modelValue: { required: false, type: [String, null] },
    isLatex: { required: false, type: Boolean, default: false },
});

const mathField = ref(null);

let emit = defineEmits(['update:modelValue']);

const expression = useVModel(props, 'modelValue', emit);

watch(
    () => props.modelValue,
    (newVal) => {
        mathField.value.setValue(newVal);
    },
);
</script>
<script>
export default {
    name: 'LatexMaybe',
};
</script>

<template>
    <LatexDisplay v-if="isLatex" :model-value="expression" />
    <span v-text="expression" v-else />
</template>
